import { CustomError } from '@core/utils';
import { skipToken } from '@tanstack/react-query';

type WithQueryFn = {
  queryFn?: unknown;
};

export type NotSkipTokenOptions<T extends WithQueryFn> = Omit<T, 'queryFn'> & {
  queryFn: Exclude<T['queryFn'], typeof skipToken | null | undefined>;
};

export const preventSkipToken = <T extends WithQueryFn>(
  options: T,
): NotSkipTokenOptions<T> => {
  if (
    options.queryFn === null ||
    options.queryFn === undefined ||
    options.queryFn === skipToken
  ) {
    throw new CustomError({
      return_message: 'skipToken 사용 불가',
    });
  }

  return options as NotSkipTokenOptions<T>;
};
